(function () {
  var root = document.querySelector("[data-cart-drawer]");
  if (!root) return;

  var panel = root.querySelector("[data-cart-panel]");
  var toggles = Array.prototype.slice.call(document.querySelectorAll("[data-cart-toggle]"));
  var toggleCounts = Array.prototype.slice.call(document.querySelectorAll("[data-cart-toggle-count]"));
  var itemsEl = root.querySelector("[data-cart-items]");
  var emptyEl = root.querySelector("[data-cart-empty]");
  var footerEl = root.querySelector("[data-cart-footer]");
  var subtotalEl = root.querySelector("[data-cart-subtotal]");
  var statusEl = root.querySelector("[data-cart-status]");
  var fallbackScript = root.querySelector("[data-cart-fallbacks]");
  var fallbackImages = {};
  var cartState = null;
  var busy = false;

  try {
    fallbackImages = fallbackScript ? JSON.parse(fallbackScript.textContent) : {};
  } catch (error) {
    fallbackImages = {};
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }
    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  function setBusy(nextBusy) {
    busy = nextBusy;
    root.classList.toggle("is-busy", busy);
    root.querySelectorAll("button").forEach(function (button) {
      if (button.hasAttribute("data-cart-toggle") || button.hasAttribute("data-cart-minimize")) return;
      button.disabled = busy;
    });
  }

  function setStatus(message) {
    if (statusEl) statusEl.textContent = message || "";
  }

  var scrollLockY = 0;
  function lockScroll() {
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = "fixed";
    document.body.style.top = "-" + scrollLockY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  }
  function unlockScroll() {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    window.scrollTo(0, scrollLockY);
  }

  function setOpen(isOpen) {
    root.dataset.state = isOpen ? "open" : "minimized";
    document.documentElement.classList.toggle("cart-drawer-open", isOpen);
    if (window.matchMedia && window.matchMedia("(max-width: 760px)").matches) {
      if (isOpen) {
        lockScroll();
      } else {
        unlockScroll();
      }
    }
    toggles.forEach(function (toggle) {
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  function getProductLabel(item) {
    if (item.handle === "puzodyssey-rotating-puzzle-board" && item.variant_title) {
      return item.variant_title;
    }
    if (!item.variant_title || item.variant_title === "Default Title") {
      return item.product_type === "Jigsaw Puzzle" ? "1000-piece puzzle" : "PuzOdyssey item";
    }
    return item.variant_title;
  }

  function getItemImage(item) {
    if (fallbackImages[item.handle]) return fallbackImages[item.handle];
    if (item.image) return item.image;
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    return "";
  }

  function renderItem(item) {
    var image = getItemImage(item);
    var title = item.product_title || item.title || "PuzOdyssey item";
    var label = getProductLabel(item);
    var lineKey = item.key || item.variant_id || item.id;
    var itemUrl = item.url || "#";

    return [
      '<article class="cart-drawer__item" data-cart-line-key="' + escapeHtml(lineKey) + '" data-cart-quantity="' + escapeHtml(item.quantity) + '">',
      '  <a class="cart-drawer__image" href="' + escapeHtml(itemUrl) + '" aria-label="View ' + escapeHtml(title) + '">',
      image
        ? '    <img alt="' + escapeHtml(title) + '" src="' + escapeHtml(image) + '">'
        : '    <span class="cart-drawer__image-placeholder">Puz</span>',
      "  </a>",
      '  <div class="cart-drawer__item-body">',
      '    <div class="cart-drawer__item-copy">',
      '      <span class="cart-drawer__item-kicker">' + escapeHtml(label) + "</span>",
      '      <a class="cart-drawer__item-title" href="' + escapeHtml(itemUrl) + '">' + escapeHtml(title) + "</a>",
      "    </div>",
      '    <div class="cart-drawer__item-meta">',
      '      <span class="cart-drawer__item-price">' + escapeHtml(formatMoney(item.final_line_price || item.line_price || item.price)) + "</span>",
      '      <div class="cart-drawer__quantity" aria-label="Quantity for ' + escapeHtml(title) + '">',
      '        <button aria-label="Decrease quantity" data-cart-quantity-action="minus" data-cart-line-key="' + escapeHtml(lineKey) + '" type="button">-</button>',
      '        <span data-cart-quantity-value>' + escapeHtml(item.quantity) + "</span>",
      '        <button aria-label="Increase quantity" data-cart-quantity-action="plus" data-cart-line-key="' + escapeHtml(lineKey) + '" type="button">+</button>',
      "      </div>",
      "    </div>",
      "  </div>",
      "</article>",
    ].join("");
  }

  function renderCart(cart) {
    cartState = cart;
    var count = cart.item_count || 0;
    toggleCounts.forEach(function (toggleCount) {
      toggleCount.textContent = count;
    });

    if (!itemsEl || !emptyEl || !footerEl) return;

    if (!count) {
      itemsEl.innerHTML = "";
      emptyEl.hidden = false;
      footerEl.hidden = true;
      if (subtotalEl) subtotalEl.textContent = formatMoney(0);
      return;
    }

    emptyEl.hidden = true;
    footerEl.hidden = false;
    itemsEl.innerHTML = cart.items.map(renderItem).join("");
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    }).then(function (response) {
      if (!response.ok) throw new Error("Unable to load cart.");
      return response.json();
    });
  }

  function refresh() {
    return fetchCart().then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function openCart() {
    setOpen(true);
    setStatus("");
    return refresh().catch(function () {
      setStatus("Unable to refresh the cart. Please try again.");
    });
  }

  function refreshAndOpen() {
    return openCart();
  }

  function minimizeCart() {
    setOpen(false);
  }

  function addForm(form, submitter) {
    if (busy) return Promise.resolve();
    setBusy(true);
    setStatus("Adding...");
    var formData = new FormData(form);
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData,
      credentials: "same-origin",
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to add item.");
        if (submitter) submitter.blur();
        return openCart();
      })
      .catch(function () {
        setOpen(true);
        setStatus("Unable to add this item. Please try again.");
      })
      .finally(function () {
        setBusy(false);
      });
  }

  function addItem(variantId, quantity) {
    if (!variantId || busy) return Promise.resolve();
    setBusy(true);
    setStatus("Adding...");
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity || 1) }),
      credentials: "same-origin",
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to add item.");
        return openCart();
      })
      .catch(function () {
        setOpen(true);
        setStatus("Unable to add this item. Please try again.");
      })
      .finally(function () {
        setBusy(false);
      });
  }

  function changeQuantity(lineKey, quantity) {
    if (!lineKey || busy) return Promise.resolve();
    setBusy(true);
    setStatus(quantity <= 0 ? "Removing..." : "Updating...");
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: Math.max(0, Number(quantity || 0)) }),
      credentials: "same-origin",
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to update item.");
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
        setStatus("");
      })
      .catch(function () {
        setStatus("Unable to update the cart. Please try again.");
      })
      .finally(function () {
        setBusy(false);
      });
  }

  function isCartUrl(href) {
    try {
      var url = new URL(href, window.location.origin);
      return url.origin === window.location.origin && url.pathname.replace(/\/$/, "") === "/cart";
    } catch (error) {
      return false;
    }
  }

  function isAddToCartForm(form) {
    if (!form || !form.action) return false;
    try {
      var url = new URL(form.action, window.location.origin);
      return url.origin === window.location.origin && url.pathname.indexOf("/cart/add") !== -1;
    } catch (error) {
      return false;
    }
  }

  document.addEventListener("submit",
    function (event) {
      var form = event.target && event.target.closest ? event.target.closest("form") : null;
      if (!isAddToCartForm(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addForm(form, event.submitter);
    },
    true
  );

  document.addEventListener("click", function (event) {
    var quantityButton = event.target.closest("[data-cart-quantity-action]");
    if (quantityButton) {
      event.preventDefault();
      var itemEl = quantityButton.closest("[data-cart-quantity]");
      var currentQuantity = itemEl ? Number(itemEl.dataset.cartQuantity || 0) : 0;
      var nextQuantity =
        quantityButton.dataset.cartQuantityAction === "plus" ? currentQuantity + 1 : currentQuantity - 1;
      changeQuantity(quantityButton.dataset.cartLineKey, nextQuantity);
      return;
    }

    var toggleButton = event.target.closest("[data-cart-toggle]");
    if (toggleButton) {
      event.preventDefault();
      openCart();
      return;
    }

    var minimize = event.target.closest("[data-cart-minimize]");
    if (minimize) {
      event.preventDefault();
      minimizeCart();
      return;
    }

    var link = event.target.closest("a[href]");
    if (link && isCartUrl(link.getAttribute("href"))) {
      event.preventDefault();
      openCart();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && root.dataset.state === "open") {
      minimizeCart();
    }
  });

  window.PuzCartDrawer = {
    addItem: addItem,
    changeQuantity: changeQuantity,
    minimize: minimizeCart,
    open: openCart,
    refresh: refresh,
    refreshAndOpen: refreshAndOpen,
  };

  refresh().catch(function () {
    setStatus("");
  });
})();
